import React from "react";

type Props = {
  children: React.ReactNode;
};
const AuthWrapperForm = ({ children }: Props) => {
  return (
    <div
      className="auth_form_wrapper
    "
    >
      {children}
    </div>
  );
};

export default AuthWrapperForm;
